// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__Kbon8","Modal--Visible":"Modal_Modal--Visible__4Rk0B","Big_modal_flex_inline":"Modal_Big_modal_flex_inline__bfbaJ"};